// Vue:
import Vue from 'vue';

// Vue mixins:
import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

// Vue directives:

// Vue components:
import euiMultichart from 'v-components/euiMultichart.vue';
import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiPanel from 'v-components/euiPanel';
import euiMermeny from 'v-components/euiMermeny';
//import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';

// Vue store:
import { ssoStatestore as store } from 'v-store/ssoStatestore';	// 'store' för jag vet inte om/hur jag kan använda ett annat namn nedan :(
//import { mapState } from 'vuex';

// Övrigt:
import objectToFormData from 'object-to-formdata';
import laggTillKopieraFlyttaEllerKlonaWidget from 'ssoLaggTillKopieraFlyttaEllerKlonaWidget';


//------------------------------------------------------------------------------------------------------------------------------

window.ssoDiagramsida = window.ssoDiagramsida || {};	// För att undvika ESLint-varningar att den är odefinierad.

// Fixa till sidans mermeny, så den är av rätt class type:
window.ssoDiagramsida.sidansMermenyConfig =
	euiPopUpMenyClasses.menyConfig.castFrom(window.ssoDiagramsida.sidansMermenyConfig, { castAlsoNestedObjectsAndArrayValues: true });		// "casta" till rätt typ, inkl alla nästade underobjekt/arrayvärden.

// Den enstaka widgeten på denna sida har ingen mermeny (utan istället har *sidan* en sådan):
//// Fixa till alla (ev) menyConfig objekt i window.ssoDiagramsida.widget, så de är av rätt class type:



//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Lokalt registrarade komponenter
	components: {
		//[euiPanel.name]: euiPanel,
		euiPanel,
		euiMultichart,
		euiMermeny,
	},

	store,	// ssoStatestore

	// Data utöver de från mixin ovan:
	data: {
		// Reaktiva data:

		widgetSettings: window.ssoDiagramsida.widget.settings,

		chartTitle: ' ',		// Sätts om då event säger att det är färdigt. Mellanslag, för höjden på huvudet blir annorlunda för '' vs. ' '!

		arIAndralage: false,


		// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

		sidansMermenyConfig: Object.freeze(window.ssoDiagramsida.sidansMermenyConfig),		// Obs! Denna är tillfixad FÖRE Vue-appen initieras (räcker inte i beforeCreate!)

		widgetData: Object.freeze(window.ssoDiagramsida.widget.data),
		widgetElementName: Object.freeze(window.ssoDiagramsida.widget.elementName),
		widgetId: Object.freeze(window.ssoDiagramsida.widget.widgetId),
		//widgetParameters: Object.freeze(window.ssoDiagramsida.widget.parameters),
	},

	methods: {
		onTitleSet(titel)
		{
			this.chartTitle = titel;
		},

		onMenyalternativValt({ eventId, eventData }) {
			switch (eventId) {
				case 'addPageAsWidget':
					{
						//console.log('addPageAsWidget', eventId, eventData);

						const toPageId = eventData;		// Enkom för tydlighet.

						// Obs! Visningen av "widgeten" på denna sida hoppar över widgetkomponenten och visar själv en eui-panel med ett multichart i, typ på samma sätt som widgetkomponenten gör:
						//
						// Det som ska sparas nedan är ändå parametrarna från widgeten.
						//
						// Har åtgärdat ett antal problem kring detta, genom att kopiera widget-posten ist:

						// Obs! Det som kopieras är alltså widget-posten, "så som den visas på sidan Kontoutdrag", för det är den widget-posten som anv även på denna diagramsida:

						laggTillKopieraFlyttaEllerKlonaWidget(this, undefined, this.widgetId, toPageId, { typLaggTillKopieraFlyttaEllerKlona: 'lägg till' });

						break;
					}

				case 'andraWidget':
				{
					// Försätt diagrammet i ändraläge:
					this.arIAndralage = true;
				}
			}
		},

		// Todo: Denna bör ev DRYas med den i ssoChartWidget.vue!
		onWidgetSettingsAndrade(nyaWidgetSettings)
		{
			// Användaren har ändrat inställningar för diagrammet:

			// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*).

			// UI och dess underliggande data är redan "live" uppdaterade med rätt nya värden (via reaktivitet).
			// Obs! DENNA "LIVE" METOD FÖRUTSÄTTER antagligen att värdena i dialogen *aldrig* kan bli invalid!
			// I detta läge är alltså, om *allt* reaktivt hunnit bli klart (!), nyaWidgetSettings (deep) === this.widgetSettings (deep).
			// Vi arbetar dock med nyaWidgetSettings här så slipper vi bekymra oss om reaktivitetens status.

			// Dialogrutan är än så länge *inte* stängd och eui-multichart-komponenten håller fortfarande undansparade gamla värdet för den eventualitet att sparningen fallerar om vi låter användaren stanna kvar i dialogen (och där kan välja Avbryt)!

			this.AjaxpostaOchHanteraResultat('/widget/update-widget-settings', {
				formData: objectToFormData({
						widgetId: this.widgetId,
						widgetElementName: this.widgetElementName,
						widgetSettings: JSON.stringify(nyaWidgetSettings),
					}),
				doljSpinnerOnSuccess: true,
				onSuccessFunction: (resultat) => {
					// Först nu ska dialogen stängas!
					// Ta widgeten ur ändraläge:
					this.arIAndralage = false;
				},
			});
		}
	},


	//== Lifecycle hooks  ================================================================================================================

});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
